export const BrandColors = {
  instagram: '#E4405F',
  facebook: '#1877F2',
  tiktok: '#000000',
  whatsapp: '#25D366',
  twitter: '#1DA1F2',
  /** Post-rebrand X (formerly Twitter) — black. Some surfaces still show the legacy blue under `twitter`. */
  x: '#000000',
  youtube: '#FF0000',
  linkedin: '#0A66C2',
  instagramGradient:
    'linear-gradient(45deg, #FEDA75, #FA7E1E, #D62976, #962FBF, #4F5BD5)',
  tiktokCyan: '#25F4EE',
  tiktokMagenta: '#FE2C55',
};
